export default "__VITE_ASSET__6e20f4a0__"